const authHeader = (withJSON = false) => {
    const user = JSON.parse(localStorage.getItem('user'));

    if (user && user.accessToken && withJSON) {
        return {
            'Content-Type': 'application/json;charset=utf-8',
            Authorization: 'Bearer ' + user.accessToken
        };
    } else if (user && user.accessToken) {
        return { Authorization: 'Bearer ' + user.accessToken };
    } else {
        return {};
    }
}

export default authHeader;
